import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "@phosphor-icons/react";
import { useContent, pick } from "../../lib/content";
import { useSite } from "../../lib/site";
import { LOCATIONS } from "../../lib/locations";
import SEO from "../../components/SEO";
import CTABand from "../../components/public/CTABand";

export default function Locations() {
  const c = useContent();
  const site = useSite();
  const businessName = site?.business_name || "ATC Home Pro's";

  const title = "Service Areas — Where ATC Home Pro's Works";
  const description = `${businessName} serves all of Southern York County, PA and Northern Maryland — from Glen Rock and Loganville to York, Hanover, Shrewsbury, and beyond. Lifetime labor warranty on every project.`;

  const baseUrl = (site?.site_url || "").replace(/\/$/, "");
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": LOCATIONS.map((l, i) => ({
      "@type": "ListItem",
      "position": i + 1,
      "name": l.full,
      "url": `${baseUrl}/locations/${l.slug}`,
    })),
  };

  return (
    <div data-testid="locations-page">
      <SEO path="/locations" title={title} description={description} jsonLd={jsonLd} />

      <section className="bg-atc-black text-white pt-20 pb-24 relative overflow-hidden">
        <div className="absolute inset-0 bg-blueprint-grid-dark bg-[size:4rem_4rem] opacity-30" />
        <div className="container-max relative">
          <div className="overline mb-4 text-atc-red">Service area</div>
          <h1 className="h-display">Where<br />we work.</h1>
          <p className="mt-6 text-white/80 text-lg max-w-2xl">
            One-hour radius from Glen Rock, PA. We cover every town in {pick(c, "home.areas_body", "Southern York County & Northern Maryland")} — pick your town to learn more.
          </p>
        </div>
      </section>

      <section className="section-pad bg-atc-paper">
        <div className="container-max">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {LOCATIONS.map((loc) => (
              <Link
                key={loc.slug}
                to={`/locations/${loc.slug}`}
                className="group border-2 border-atc-black bg-white p-6 block transition-all hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[8px_8px_0_0_#1A1A1A]"
                data-testid={`location-card-${loc.slug}`}
              >
                <div className="flex items-start gap-3 mb-4">
                  <MapPin size={22} weight="bold" className="text-atc-red shrink-0 mt-1" />
                  <div>
                    <div className="overline mb-1">{loc.region}</div>
                    <h3 className="font-display text-2xl uppercase leading-tight">{loc.name}, {loc.state}</h3>
                  </div>
                </div>
                <p className="text-sm text-atc-muted leading-relaxed line-clamp-3">{loc.anchor}</p>
                <div className="mt-5 inline-flex items-center gap-2 text-xs font-heading uppercase tracking-widest group-hover:text-atc-red">
                  View {loc.name} <ArrowUpRight size={12} weight="bold" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABand phone={site?.phone} />
    </div>
  );
}
